import React, { useEffect, useState } from 'react';
import { ReactComponent as IngredientsRect } from 'Icons/Sidebar/IngredientsRect.svg';
import { IStyle } from 'Styles';
import { WellLayerDTO } from 'business/models/Models';
import { WellInfoItemType } from '../Contants';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import { selectedIngredientList } from 'redux/selectors/StateSelectors';
import { isCtrlKeyPressed } from 'utils/Global';
import {
  useAllPlates,
  useAllWellNavigationDetails,
  useSelectedDropImageParameters,
} from 'redux/hooks/experiment';
import {
  appendWellNavigationDetails,
  setWellImagingSettingDetails,
  setWellNavigationDetails,
} from 'redux/reducers/experimentDataReducer';
import { DropImageParameters } from 'components/Experiment/constants';
import { batch } from 'react-redux';

export interface WellCardProps {
  wellInfoItem: WellInfoItemType;
}

const WellCard = (props: WellCardProps) => {
  const { wellInfoItem } = props;
  const [activeWellCardIds, setActiveWellCardIds] = useState([]);
  const [isControlKeyPressed, setIsControlKeyPressed] = useState(false);
  const dispatch = useRMDispatch();
  const selectedIngredientsList = useRMSelector(selectedIngredientList);
  const allPlates = useAllPlates();
  const wellNavigationDetails = useAllWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { dropNumber } = selectedDropImageParameters;

  useEffect(() => {
    'keyup keydown'.split(' ').forEach(function (e) {
      window.addEventListener(e, handleUserKeyPress);
    });

    return () => {
      'keyup keydown'.split(' ').forEach(function (e) {
        window.removeEventListener(e, handleUserKeyPress);
      });
    };
  }, [handleUserKeyPress]);

  useEffect(() => {
    if (wellNavigationDetails?.length) {
      changeWellSelection();
    }
  }, [wellNavigationDetails]);

  function handleUserKeyPress(e) {
    if (isCtrlKeyPressed(e) == true) {
      if (isControlKeyPressed == false) {
        setIsControlKeyPressed(true);
      }
    } else {
      if (isControlKeyPressed == true) {
        setIsControlKeyPressed(false);
      }
    }
  }

  const getWellIngredients = (wellInfoItem) => {
    return wellInfoItem?.wellLayerList.map((wellLayer) =>
      wellLayer.wellLayerIngredientList.map((ingredient) => (
        <div key={`wC${ingredient?.id}`}>
          {selectedIngredientsList?.length
            ? selectedIngredientsList.includes(
                ingredient.ingredientStockIngredient.longName,
              )
              ? `${parseFloat(ingredient.concentration.toFixed(2))} ${
                  ingredient.ingredientStock?.concentrationUnits
                } ${ingredient.volume} ${ingredient.ingredientStockIngredient.longName}`
              : ``
            : `${parseFloat(ingredient.concentration.toFixed(2))} ${
                ingredient.ingredientStock?.concentrationUnits
              } ${ingredient.volume} ${ingredient.ingredientStockIngredient.longName}`}
        </div>
      )),
    );
  };

  const getWellCardTitleInfo = (
    label: string,
    value: number | string | boolean | WellLayerDTO[],
  ) => {
    return <span style={styles.wellCardTitleInfo}>{`${label}${value}`}</span>;
  };

  const onClickWellCard = (plateId, wellNumber, dropNumber) => {
    const plateNum = allPlates?.find((pl) => pl.plateId === plateId)?.plateNumber;
    const newWellDetail = { plateID: plateId, wellNum: wellNumber, plateNum };
    const wellInfo: DropImageParameters = {
      ...selectedDropImageParameters,
      dropNumber,
    };
    if (isControlKeyPressed) {
      batch(() => {
        dispatch(setWellImagingSettingDetails([wellInfo]));
        dispatch(appendWellNavigationDetails(newWellDetail));
      });
    } else {
      batch(() => {
        dispatch(setWellImagingSettingDetails([wellInfo]));
        dispatch(setWellNavigationDetails([newWellDetail]));
      });
    }
  };

  const changeWellSelection = () => {
    const activeWells = [];
    for (const well of wellNavigationDetails) {
      document
        .getElementById(`${well?.plateID}${well?.wellNum}${dropNumber}`)
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'start',
        });
      activeWells.push(`${well?.plateID}${well?.wellNum}${dropNumber}`);
    }
    setActiveWellCardIds(activeWells);
  };

  return (
    <div 
      //@ts-ignore
      style={styles.wellCard(
        activeWellCardIds.includes(
          `${wellInfoItem.plateId}${wellInfoItem.wellNumber}${wellInfoItem.dropNumber}`,
        )
          ? true
          : false,
      )}
      id={`exp-wellinfo-card-${wellInfoItem.plateId}${wellInfoItem.wellNumber}${wellInfoItem.dropNumber}`}
      onClick={() =>
        onClickWellCard(
          wellInfoItem.plateId,
          wellInfoItem.wellNumber,
          wellInfoItem.dropNumber,
        )
      }
    >
      <div id='exp-wellinfo-card-title' style={styles.wellTitle}>
        {getWellCardTitleInfo('Plate ', wellInfoItem?.plateNumber)}
        {getWellCardTitleInfo(' Well ', wellInfoItem?.wellRow)}
        {getWellCardTitleInfo('', wellInfoItem?.wellCol)}
        {wellInfoItem?.dropNumber &&
          getWellCardTitleInfo(' Drop ', wellInfoItem?.dropNumber)}
      </div>
      <div id='exp-wellinfo-card-infotab' className="flex-container" style={styles.infoTab}>
        <div id='exp-wellinfo-card-ingrect' style={styles.svg}>
          <IngredientsRect />
        </div>
        <div id='exp-wellinfo-card-ingname' style={styles.ingNames}>
          {wellInfoItem.wellScores}
          {getWellIngredients(wellInfoItem)}
        </div>
      </div>
    </div>
  );
};

const styles: IStyle = {
  wellCardTitleInfo: {
    marginTop: '10px',
    fontWeight: 'bold',
    fontSize: '0.9rem',
  },
  //@ts-ignore
  wellCard: (isActive: boolean) => ({
    marginTop: '2px',
    marginLeft: '2%',
    border: '1px solid #BDBDBD',
    borderRadius: '5px',
    backgroundColor: `${isActive ? `rgba(214, 232 , 255, 1)` : `white`}`,
  }),
  wellTitle: {
    marginTop: '5px',
    marginLeft: '2%',
  },
  svg: {
    marginLeft: '2%',
    width: '5%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  ingNames: {
    marginLeft: '2%',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '0.9rem',
  },
  infoTab: {
    marginBottom: '3%',
  },
};

export default WellCard;
